import type { BlogPost } from '#app/data/blog'
import { BlogCard } from './BlogCard'

export function RelatedPosts({ posts }: { posts: BlogPost[] }) {
	if (posts.length === 0) return null

	return (
		<div>
			<h2 className="mb-6 font-['Futura_Hv_BT'] text-[22px] text-[#32302F] md:text-[28px]">
				Related Articles
			</h2>
			<div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
				{posts.map((post) => (
					<BlogCard key={post.slug} post={post} />
				))}
			</div>
		</div>
	)
}
